export default {
    setLoading({ commit }, payload) {
        if (payload.state) {
            commit('startLoading', payload.id);
        } else {
            commit('stopLoading', payload.id);
        }
    },
};
